<template lang="html">
  <div>
    <div class="content">
      <h1>Poukazy</h1>
      <v-layout class="layout--controls">
        <v-btn
            color="secondary"
            class="button--top control"
            :href="exportLink"
            download
        >Exportovat
        </v-btn>
        <v-btn
            color="primary"
            type="submit"
            class="button--top control"
            @click="addVoucher()"
        >Vytvořit poukaz
        </v-btn>
        <v-text-field
            class="input--search control"
            placeholder="Vyhledat"
            outlined
            v-model="search"
        ></v-text-field>
        <div class="button--top control">
          <v-select
              class="control select--top"
              :items="createdTypes"
              v-model="createdType"
              outlined
              item-value='type'
              item-text='name'
              placeholder="Vydavatel"
          ></v-select>
        </div>

      </v-layout>
      <v-layout class="table-items">


        <v-data-table

            locale="cs"
            :headers="headers"
            :items="items"
            sort-by="id"
            sort-desc
            :loading="false"
            item-key="name"
            :items-per-page="perPage"
            :options.sync="options"
            :server-items-length="total"
            :mobile-breakpoint='0'
            class="elevation-1 full-width frankjoy-table"
        >
          <template #progress>
            <div></div>
          </template>
          <template slot="body" slot-scope="props">
            <tbody>
            <tr v-for="item in props.items" :key="item.id">
              <router-link :to="{name:'VouchersDetail', params: {id: item.id}}">
                <td class="">{{ item.id }}</td>
                <td class="bold uppercase">{{ item.code }}</td>
                <td class="">{{ getTypeName(item.type) }}</td>
                <td class="smaller" v-html="item.value"></td>
                <td class="smaller">{{ item.used }}</td>
                <td class="small bold">
                  <span v-if="item.valid === 'yes'" class="status status--success">K použití</span>
                  <span v-else-if="item.valid === 'no'" class="status">Použit</span>
                  <span v-else-if="item.valid === 'expired'" class="status status--error">Expirován</span>
                  <span v-else-if="item.valid === 'not_yet'" class="status status--normal">Zatím nedostupný</span>
                </td>
                <td class="small">
                  <span v-if="item.valid_to">{{ formatCreatedAt(item.valid_to) }}</span>
                  <span v-else>neomezeně</span>
                </td>

                <td class="smaller">
                                <span v-if="item.created_by">
                                  {{ getCreatedByName(item.created_by) }}
                                </span>

                </td>

                <td class="smaller">{{ item.note }}</td>
                <td class="right">
                  <v-btn
                      color="primary"
                      type="submit"
                      class="button--small"
                  >Detail
                  </v-btn>
                </td>
              </router-link>

            </tr>
            <div v-if="props.items.length == 0" class="text-no-results">
              <p>Žádný poukaz nebyl nalezen</p>
            </div>
            <v-overlay
                absolute
                color="rgba(255, 255, 255, 0.8)"
                :value="!loaded"
            >
              <div>
                <div class="loader">
                  <div class="loader__item">
                  </div>
                </div>
              </div>
            </v-overlay>
            </tbody>

          </template>


          <template slot="footer" slot-scope="totals">

            <div class="table-footer" v-bind:class="{'footer--no-results': totals.props.pagination.pageStop === 0}">
              <div class="table-footer__text">
                Počet poukazů na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"><span
                    class="table-footer__pages-bold">{{ totals.props.pagination.pageStart + 1 }}-{{ totals.props.pagination.pageStop }}</span> z {{ totals.props.pagination.itemsLength }}</span>
                <span v-else><span
                    class="table-footer__pages-bold">{{ totals.props.pagination.pageStart }}-{{ totals.props.pagination.pageStop }}</span> z {{ totals.props.pagination.itemsLength }}</span>
              </div>
            </div>
          </template>
        </v-data-table>


      </v-layout>
    </div>


  </div>
</template>


<script>
import {mapState} from 'vuex';
import moment from 'moment';
import {debounce} from 'lodash';

export default {
  name: 'Vouchers',

  data() {
    return {
      createdType: 'all',
      json: {
        data: [],
        labels: {},
        title: 'Poukazy',
        file: 'Poukazy',
        meta: [
          [{
            "key": "charset",
            "value": "utf-8"
          }]
        ],
      },
      loaded: false,
      search: '',
      createdTypes: [
        {
          type: 'all',
          name: 'Všechny'
        },
        {
          type: 'no_activity_6_months',
          name: 'Neaktivita 6 měsíců'
        },
        {
          type: 'no_activity_3_months',
          name: 'Neaktivita 3 měsíce'
        },
        {
          type: 'birthday',
          name: 'Narozeniny'
        },
        {
          type: 'order',
          name: 'Objednávka'
        },
        {
          type: 'review_book',
          name: 'Recenze audioknihy'
        },
        {
          type: 'admin',
          name: 'Admin'
        },
      ],
      headers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        {text: 'ID', value: 'id', align: 'left',},
        {text: 'Kód', value: 'code', align: 'left',},
        {text: 'Typ', value: 'type', align: 'left',},
        {text: 'Hodnota', value: 'value', align: 'left', sortable: false},
        {text: 'Počet použití', value: 'used', align: 'left',},
        {text: 'Stav', value: 'valid_status', align: 'left',},
        {text: 'Platnost do', value: 'valid_to', align: 'left',},
        {text: 'Vytvořil', value: 'created_by', align: 'left',},
        {text: 'Poznámka', value: 'note', align: 'left',},
        {text: '', value: 'controls', align: 'right',}
      ],
      items: [],
      options: {},
      total: 0,
      perPage: 30,
      types: [
        {value: 'audiobook', name: 'Audiokniha'},
        {value: 'book', name: 'Tištěná kniha'},
        {value: 'ebook', name: 'E-kniha'},
        {value: 'ebook_crowns', name: 'Sleva na e-knihu'},
        {value: 'ebook_percentage', name: 'Sleva na e-knihu'},
        {value: 'book_crowns', name: 'Sleva na tištěnou knihu'},
        {value: 'book_percentage', name: 'Sleva na tištěnou knihu'},
        {value: 'audiobook_percentage', name: 'Sleva na audioknihu'},
        {value: 'category_percentage', name: 'Sleva na kategorii'},
        {value: 'audiobook_crowns', name: 'Sleva na audioknihu'},
        {value: 'percentage', name: 'Sleva na nákup'},
        {value: 'crowns', name: 'Sleva na nákup'},
      ],
    }
  },

  created() {


    this.fetchData();

  },
  computed: {
    ...mapState(['profile']),
    exportLink() {
      return process.env.VUE_APP_API_BASE_URL + '/admin/vouchers.xlsx?token=' + localStorage.getItem('token');
    },
  },
  mounted() {
  },
  methods: {
    getCreatedByName(type) {
      const found = this.createdTypes.find(item => item.type === type);
      if (found) {
        return found.name;
      } else {
        return type;
      }
    },
    getTypeName(type) {
      const found = this.types.find(item => item.value === type);
      if (found) {
        return found.name;
      } else {
        return type;
      }
    },
    addVoucher() {
      this.$router.push({name: 'VouchersDetail', params: {id: 'add'}})
    },
    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format('D.M.YYYY');
      } else {
        return null;
      }

    },
    fetchData() {
      this.loaded = false;
      this.items = [];
      const params = {};
      if(this.options.page){
        params.page = this.options.page;
      }
      if(this.options.itemsPerPage)
      {
        params.perPage = this.options.itemsPerPage;
      }
      if(this.options.sortBy && this.options.sortBy.length > 0){
        params.sortBy = this.options.sortBy[0];
      }
      if(this.options.sortDesc && this.options.sortDesc.length > 0){
        params.order = this.options.sortDesc[0] ? 'DESC' : 'ASC';
      }
      if(this.search && this.search.length > 0){
        params.search = this.search;
      }
      if (this.createdType && this.createdType != 'all') {
        params.createdBy = this.createdType;
      }
      this.$axios.get('/admin/vouchers', { params }).then((response) => {

        response.data.vouchers.forEach(item => {
          if (item.valid == 'yes') {
            item.valid_text = 'K použití';
          } else if (item.valid == 'no') {
            item.valid_text = 'Použit';
          } else if (item.valid == 'expired') {
            item.valid_text = 'Expirován';
          } else if (item.valid == 'not_yet') {
            item.valid_text = 'Zatím nedostupný';
          }
        });

        this.items = response.data.vouchers;
        this.total = response.data.count;
        this.loaded = true;
      }).catch((e) => {
        this.loaded = true;
      });
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
    search: debounce(function (val) {
      this.fetchData();
    }, 500),
    createdType: function (val) {
      this.fetchData();
    }
  }
}
</script>


<style lang="scss">


</style>
